import { Capacitor } from '@capacitor/core'
import { type ClassValue, clsx } from "clsx"
import moment from 'moment'
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatDate = (date: string) => moment(date).format('DD/MM/YYYY')
export const formatDateTime = (date: string) => moment(date).format('DD/MM/YYYY HH:mm')

export const getPlatformFlags = (): PlatformFlags => {
  const isNativeMobile = Capacitor.isNativePlatform() && ['android', 'ios'].includes(Capacitor.getPlatform())
  if (typeof navigator === 'undefined') return { isMobile: isNativeMobile, isNativeMobile }

  const userAgent = navigator.userAgent || ''
  const isMobileWeb = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

  return { isMobile: isNativeMobile || isMobileWeb, isNativeMobile }
};

export const safeJsonParse = <T = any>(str: string | null, fallback: T | null = null): T | null => {
  if (!str) return fallback;
  try { return JSON.parse(str) as T; }
  catch {
    try {
      localStorage.removeItem('@5-techs/user');
      localStorage.removeItem('@5-techs/token');
      localStorage.removeItem('@5-techs/super_original_user');
      localStorage.removeItem('@5-techs/super_original_token');
    } catch {}
    return fallback;
  }
};

export const safeLocalRemoveAuth = () => {
  try {
    localStorage.removeItem('@5-techs/user');
    localStorage.removeItem('@5-techs/token');
    localStorage.removeItem('@5-techs/super_original_user');
    localStorage.removeItem('@5-techs/super_original_token');
  } catch {}
};

// Explicação/justificativa com passos numerados ("1) ...; 2) ...") vira um passo por linha; o texto sem passos numerados não muda.
export const formatarPassosEmLinhas = (texto: string | null | undefined): string => {
  if (!texto) return ""
  return String(texto)
    .replace(/([;.:!?])[ \t]+(?=\d{1,2}\)[ \t])/g, "$1\n")
    .replace(/([;.])[ \t]+(?=Resultado final)/gi, "$1\n")
}

export const corBadgeNotaIa = (percentual: number): string => {
  if (percentual > 60) return 'bg-green-500'
  if (percentual >= 50) return 'bg-yellow-500'
  return 'bg-red-500'
}
